import { NgModule } from '@angular/core';
import { AnalyticsModule } from '@ddt-web/analytics';
import { EffectsModule } from '@ngrx/effects';

import { FundTagEffects } from './store/fund-tag.effects';

@NgModule({
	imports: [
		EffectsModule.forFeature([FundTagEffects]),
		AnalyticsModule
	]
})
export class FundTagModule { }
